// Testimonial slider
jQuery(function ($) {
    var $sliders = $('.gallery-slider-section__slider--wrap');

    if ($sliders.length) {
        $sliders.each(function () {
            var $slider = $(this);

            if ($slider.hasClass('slick-initialized')) {
                return; // avoid re-init if loaded via AJAX
            }

            $slider.slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                arrows: false,
                dots: true,
                infinite: true,
                speed: 600,
                autoplay: true,
                adaptiveHeight: false,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1
                        }
                    }
                ]
            });
        });
    }
});